const initialState = {
  organizationListContext: [],
  organogramListContext: [],
  userListContext: [],
  roleListContext: [],
  groupListContext: [],
  employeeListContext: [],
  locationListContext: [],
  departmentListContext: [],
  productListContext: [],
  designationListContext: [],
  lookupListContext: [],
  enumListContext: [],
  componentListContext: [],
};

export default initialState;
